import React from 'react'
import cl from 'classnames'
import styles from './Tab.module.scss'
import { TabProps } from './Tab.types'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { VIEWERS_STORE } from 'store'

const TabComponent = (props: TabProps) => {
  const {
    label,
    isFirst,
    isLast,
    [VIEWERS_STORE]: { selectedSortTab, setSelectedSortTab }
  } = props

  const isSelected = selectedSortTab === label

  const handleClick = () => {
    setSelectedSortTab(label)
  }

  return (
    <button
      className={cl(styles.container, {
        [styles.selected]: isSelected,
        [styles.first]: isFirst,
        [styles.last]: isLast
      })}
      onClick={handleClick}
    >
      {label}
    </button>
  )
}

const Tab = inject('VIEWERS_STORE')(observer(TabComponent))
export { Tab }
